import { render, staticRenderFns } from "./BlogCategories.vue?vue&type=template&id=3cdffb1f&scoped=true&"
import script from "./BlogCategories.vue?vue&type=script&lang=js&"
export * from "./BlogCategories.vue?vue&type=script&lang=js&"
import style0 from "./BlogCategories.vue?vue&type=style&index=0&id=3cdffb1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdffb1f",
  null
  
)

export default component.exports